module.exports = __webpack_public_path__ + "img/logo.eb433a2e.png";